import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import theme from '../../../common/theme';

interface Props {
  label: string;
}

const Badge: React.FC<Props> = ({ label }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>{label}</Text>
    </View>
  );
};

export default Badge;

const styles = StyleSheet.create({
  container: {
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.pink,
    marginRight: 8,
  },
  label: {
    fontSize: 12,
    lineHeight: 16,
    color: theme.palette.white,
    fontFamily: theme.fonts.regular,
  },
});
